<app-dialog #dialog
            (cancel)="cancelButtonClicked()"
            (confirm)="deleteButtonClicked()"
            cancelButtonText="Cancel"
            confirmButtonText="Delete"
            confirmButtonColor="warn"
            title="Are you sure that you want to delete this note?">
  <p>This action <b>cannot</b> be undone. The note will be removed from the patient's profile, and will no longer be accessible.</p>
</app-dialog>
